import { RouteObject } from "react-router-dom";
import { SETTING } from "constants/urls";

export default [
  {
    index: true,
    path: SETTING,
    lazy: () => import("modules/setting/pages/Setting"),
  },
] as RouteObject[];
